import { Input } from "antd";
import React from "react";
import styled from "styled-components";
import Button from "../../../../components/atoms/Button";
import Explain from "../../../../components/atoms/Explain";
import { StatusType } from "../../../../components/atoms/Explain/types";
import { InputPropsType } from "../../../../components/atoms/Inputs/InputPropsT";
import { PLACEHOLDER } from "../../../../components/constants";

import { theme } from "../../../../theme";

interface InputsProps extends InputPropsType {
  onChangeAuth: (e: string) => void;
  onExplainClick?: () => void;
  onSendPhone?: any;
  onVerifyAuth?: any;
  height?: number;
  phoneValue?: string;
  authNumValue?: string;
  isAuthPassed?: boolean;
  isNotBordered?: true;
  isPhoneSended?: boolean;
  additionalBtn?: any;
  phoneStatus?: StatusType;
  authStatus?: StatusType;
  phoneExplain?: string;
  authExplain?: string;
  maxLength?: number;
  counter: number;
  minuteText?: string;
  secondText?: string;
  stopCounter: () => void;
}
const AuthTokenInput: React.FC<InputsProps> = ({
  authNumValue,
  disabled,
  authStatus,
  isAuthPassed,

  name,
  height,
  onChangeAuth,
  minuteText,
  secondText,
  authExplain,
  maxLength,
  onExplainClick,

  onVerifyAuth,
}) => {
  const styles = {
    height,
    name,
  };

  // useEffect(() => {
  //   if (counter <= 0) stopCounter();
  // }, [counter]);
  const onVerify = () => {
    onVerifyAuth();
  };
  return (
    <SendAuthInputContainer>
      <NotBorderedInputWrapper status={authStatus}>
        <NotBorderedInput
          value={authNumValue}
          disabled={disabled}
          placeholder={PLACEHOLDER.NUMBER}
          autoComplete="new-password"
          className="notBordered"
          onPressEnter={onVerify}
          maxLength={maxLength}
          {...styles}
          onChange={(e) => onChangeAuth(e.target.value)}
        />
        {!isAuthPassed && (
          <StyledTimeCounterWrapper>
            {`${minuteText}:${secondText}`}
          </StyledTimeCounterWrapper>
        )}
        <StyledBtnWrapper disabled={disabled}>
          <Button
            disabled={disabled}
            onClick={onVerify}
            type="primary"
            size="large"
            ghost
          >
            인증번호 확인
          </Button>
        </StyledBtnWrapper>
      </NotBorderedInputWrapper>
      {authExplain && authExplain.length > 0 && (
        <Explain
          explain={authExplain}
          onClick={onExplainClick}
          status={authStatus}
        />
      )}
    </SendAuthInputContainer>
  );
};
export default AuthTokenInput;

const NotBorderedInputWrapper = styled.div<{ status?: StatusType }>`
  position: relative;
  display: flex;
  flex-wrap: no-wrap;
  border-bottom: 1px solid #d2d2d2;
  box-sizing: border-box;
  :hover {
    outline: none;
    box-shadow: none;
    border-color: none;
  }
  :focus-within {
    outline: none;
    box-shadow: none;

    border-bottom: 1px solid ${theme.colors.mainPrimary3};
    outline-bottom: 1px solid ${theme.colors.mainPrimary3};
  }

  border-color: ${({ status }) => {
    switch (status) {
      case "success":
        return theme.colors.blue2;
      case "error":
        return theme.colors.red3;
      default:
        return theme.colors.gray6;
    }
  }};
`;

const SendAuthInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;
const NotBorderedInput = styled(Input)<{
  height?: number;
  onClick?: any;
}>`
  background-color: #fff;
  border: none;

  box-sizing: border-box;
  background: none;
  padding: 16px 4px;
  border-radius: 0px;
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : "56px")};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "text")};

  ${theme.typo.body.r16};
  :disabled {
    background-color: ${theme.colors.gray9};
    color: black;
  }
  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    box-shadow: 0 0 0 30px white inset !important;
  }
  :-webkit-autofill {
    font-size: inherit;
  }
  &::placeholder {
    ${theme.typo.body.r14};
    color: ${theme.colors.gray3};
  }
  :hover {
    outline: none;
    box-shadow: none;
    border-color: none;
  }
  :focus {
    outline: none;
    box-shadow: none;
  }
`;
const StyledBtnWrapper = styled.div<{ disabled?: boolean }>`
  flex: 1 1 0;
  right: 0;
  align-items: center;
  display: flex;
  background-color: ${({ disabled }) => disabled && theme.colors.gray9};
  align-items: center;
`;
const StyledTimeCounterWrapper = styled.div`
  color: ${theme.colors.red3};
  display: flex;
  align-items: center;
  margin-right: 16px;
  ${theme.typo.body.r14};
`;
